import { render } from "./sandTableCollapse2.vue?vue&type=template&id=6e646fdc&scoped=true"
import script from "./sandTableCollapse2.vue?vue&type=script&lang=js"
export * from "./sandTableCollapse2.vue?vue&type=script&lang=js"

import "./sandTableCollapse2.vue?vue&type=style&index=0&id=6e646fdc&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e646fdc"]])

export default __exports__